import { jsx as E } from "react/jsx-runtime";
import s from "react";
function b(e) {
  var o, i, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (o = 0; o < r; o++) e[o] && (i = b(e[o])) && (n && (n += " "), n += i);
  } else for (i in e) e[i] && (n && (n += " "), n += i);
  return n;
}
function $() {
  for (var e, o, i = 0, n = "", r = arguments.length; i < r; i++) (e = arguments[i]) && (o = b(e)) && (n && (n += " "), n += o);
  return n;
}
const k = s.createContext({
  initialAnimateComplete: !1,
  motionElements: [],
  setMotionElements: () => {
  },
  presenceMap: [],
  previousPresenceMap: []
}), D = ({
  motionKey: e,
  exitDuration: o
}) => {
  const {
    presenceMap: i,
    setMotionElements: n,
    previousPresenceMap: r,
    initialAnimateComplete: p
  } = s.useContext(k);
  return s.useEffect(() => {
    if (!(!e || !o))
      return n((f) => f.filter(
        (u) => e === u.motionKey
      ).length > 0 ? f : [...f, { motionKey: e, exitDuration: o }]), () => {
        n((f) => f.filter(
          (u) => e === u.motionKey
        ));
      };
  }, [o, e, n]), {
    presence: s.useMemo(() => {
      var l, c;
      const f = (l = i.find(
        (h) => h["tgph-motion-key"] === e
      )) == null ? void 0 : l.value, m = (c = r.find(
        (h) => h["tgph-motion-key"] === e
      )) == null ? void 0 : c.value;
      return f === m;
    }, [e, i, r]),
    initialAnimateComplete: p
  };
}, N = ({ presenceMap: e, children: o }) => {
  const [i, n] = s.useState(!1), [r, p] = s.useState(o), [a, f] = s.useState([]), [m, u] = s.useState(e);
  return s.useEffect(() => {
    const l = e;
    let c;
    if ((l == null ? void 0 : l.some(
      (d) => {
        var g;
        return d.value !== ((g = m == null ? void 0 : m.find(
          (v) => v["tgph-motion-key"] === d["tgph-motion-key"]
        )) == null ? void 0 : g.value);
      }
    )) || // Check if array has changed lengths
    (l == null ? void 0 : l.length) !== (m == null ? void 0 : m.length)) {
      const d = Math.max(
        ...a.map((g) => g.exitDuration)
      );
      c = setTimeout(() => {
        p(o), u(l);
      }, d);
    } else
      p(o), u(l);
    return () => c && clearTimeout(c);
  }, [o, a, e, m]), s.useEffect(() => {
    i || n(!0);
  }, [i]), /* @__PURE__ */ E(
    k.Provider,
    {
      value: {
        presenceMap: e,
        previousPresenceMap: m,
        initialAnimateComplete: i,
        motionElements: a,
        setMotionElements: f
      },
      children: r
    }
  );
}, C = {
  "ease-in-out": "ease-in-out",
  "ease-in": "ease-in",
  "ease-out": "ease-out",
  linear: "linear",
  spring: "linear(0, 0.25, 1)"
}, A = C["ease-in-out"], F = (e) => {
  if (!e) return A;
  const o = C == null ? void 0 : C[e];
  return o || A;
}, M = ({
  as: e,
  status: o = "initial",
  className: i,
  initial: n,
  animate: r,
  exit: p,
  transition: a,
  initializeWithAnimation: f = !0,
  style: m,
  children: u,
  "tgph-motion-key": l,
  onAnimationComplete: c,
  ...h
}) => {
  const d = e || "div", { presence: g, initialAnimateComplete: v } = D({
    motionKey: l || "",
    exitDuration: (a == null ? void 0 : a.duration) || 0
  }), [t, P] = s.useState(
    f === !1 && v === !1 ? r : n
  ), [y, T] = s.useState(
    f === !1 && v === !1 ? "animate" : "initial"
  );
  s.useEffect(() => {
    g === !1 && y === "animate" && T("exit");
  }, [g, y]), s.useEffect(() => {
    o === "initial" && T("animate"), o === "exit" && T("exit");
  }, [o]), s.useEffect(() => {
    let x;
    return y === "initial" && (x = setTimeout(() => {
      P(n);
    }, 10)), y === "animate" && (x = setTimeout(() => {
      P(r), c && setTimeout(() => {
        c();
      }, 10);
    }, 10)), y === "exit" && (x = setTimeout(() => {
      P(p);
    }, 10)), () => x && clearTimeout(x);
  }, [y, o, n, r, p, c]);
  const S = f === !1 && v === !1 ? 0 : a == null ? void 0 : a.duration;
  return (
    // @ts-expect-error - CSS variables inline throws a type error, but it's valid HTML.
    /* @__PURE__ */ E(
      d,
      {
        className: $("tgph-motion", i),
        style: {
          "--motion-opacity": t == null ? void 0 : t.opacity,
          "--motion-scale": t == null ? void 0 : t.scale,
          "--motion-x": typeof (t == null ? void 0 : t.x) == "number" ? `${t == null ? void 0 : t.x}px` : typeof (t == null ? void 0 : t.x) == "string" ? t == null ? void 0 : t.x : null,
          "--motion-y": typeof (t == null ? void 0 : t.y) == "number" ? `${t == null ? void 0 : t.y}px` : typeof (t == null ? void 0 : t.y) == "string" ? t == null ? void 0 : t.y : null,
          "--motion-rotate": typeof (t == null ? void 0 : t.rotate) == "number" ? `${t == null ? void 0 : t.rotate}deg` : null,
          "--motion-transition-duration": `${S}ms`,
          "--motion-transition-type": F(
            a == null ? void 0 : a.type
          ),
          ...m
        },
        ...h,
        children: u
      }
    )
  );
};
M.displayName = "Motion";
const L = {
  div: (e) => /* @__PURE__ */ E(M, { as: "div", ...e }),
  span: (e) => /* @__PURE__ */ E(M, { as: "span", ...e }),
  button: (e) => /* @__PURE__ */ E(M, { as: "button", ...e })
};
export {
  N as AnimatePresence,
  M as Motion,
  L as motion
};
//# sourceMappingURL=index.mjs.map
